import { IconBase, IconProps } from './Base'

export const IconCheck = (props: IconProps) => (
  <IconBase width={props.width || 24} height={props.height || 24} viewBox="0 0 24 24" fill="none">
    <g id="check">
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.207 6.79303C20.3945 6.98056 20.4998 7.23487 20.4998 7.50003C20.4998 7.76519 20.3945 8.0195 20.207 8.20703L10.707 17.707C10.5195 17.8945 10.2651 17.9998 9.99998 17.9998C9.73482 17.9998 9.48051 17.8945 9.29298 17.707L4.79298 13.207C4.61082 13.0184 4.51003 12.7658 4.51231 12.5036C4.51458 12.2414 4.61975 11.9906 4.80516 11.8052C4.99057 11.6198 5.24138 11.5146 5.50358 11.5124C5.76578 11.5101 6.01838 11.6109 6.20698 11.793L9.99998 15.586L18.793 6.79303C18.9805 6.60556 19.2348 6.50024 19.5 6.50024C19.7651 6.50024 20.0195 6.60556 20.207 6.79303Z"
        fill={props.fill || '#00A7E3'}
      />
    </g>
  </IconBase>
)
